/**
 * api 统一封装方法
 * @description api集合为元数据，可直接在页面使用 this.$api[module][api]某某方法
 * @example api.login.logout(queryOrBodyData, opt)
 *
 * @param {Object} queryOrBodyData? 查询参数 或者 荷载数据
 * @param {Boolean} opt axios配置
 *
 * @return {Object<{ data }>}
 */

import axios, { domain } from '@/plugins/axios';

// 首页
import indexApi from './modules/index.api';


// 合并所有模块api并导出到外部， 可直接在页面使用 this.$api.某某方法
const APIS = {
    index:indexApi,
}

/**
 * 请求前 中间件
 * @param {ApiMeta} apiMeta API元数据
 * @param {Query/Body} data 请求数据
 */
function foreRequestMiddleWare (apiMeta, data) {
    const { schema, name } = apiMeta;
};

/**
 * 请求失败后 中间件
 * @param {ApiMeta} apiMeta API元数据
 * @param {Error} error 请求错误对象
 * @param {Function} next 下一步
 */
function fallbackMiddleWare (apiMeta, error, next) {
    const { name, method, url } = apiMeta;

    console.error(`[${method}][${domain}${url}]: ${name} 失败，${error.message}`);
    // Message.error(`${name} 失败，${error.message}`);
    next(error);
};

// 将单个模块的 meta 转换为 请求
function Proxyable(target) {
    const target_ = {};
    for (const key in target) {
        if (target.hasOwnProperty(key)) {
            target_[key] = ProxyApi(target, key);
        }
    }
    return target_;
}

// 将 ApiMeta 映射为 http 请求
function ProxyApi(target, key) {
    if (!target[key]) throw new ReferenceError('API ' + key + ' not exist');

    const {
        method,
        url,
        name
    } = target[key];
    let timeStamps = Date.parse(new Date()) / 1000;
    if (method.toUpperCase() === 'GET') {
        return (query = {}, opt) => new Promise((resolve, reject) => {
            foreRequestMiddleWare(target[key], query);

            axios.get(url, Object.assign({}, {
                "params": query,
            }, opt))
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    } else if (method.toUpperCase() === 'POST') {
        return (body = {}, opt) => new Promise((resolve, reject) => {
            foreRequestMiddleWare(target[key], body);
            axios.post(url, body,opt)
                .then(data => resolve(data))
                .catch(err => {
                    fallbackMiddleWare(target[key], err, reject)
                });
        })
    }else {
        throw new Error('【API】API源数据信息错误，不支持的方法：' + method);
    }
}

const API_ = {};
Object.keys(APIS).forEach(apiName => {
    API_[apiName] = Proxyable(APIS[apiName]);
});

export default API_;
